<template>
    <div class="invoicePay-secondStep">
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form.lastName"
            :validation="$v.form.lastName"
            label="Фамилия плательщика"
            :disabled="true"
        />
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form.firstName"
            :validation="$v.form.firstName"
            label="Имя плательщика"
            :disabled="true"
        />
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form.patronymic"
            :validation="$v.form.patronymic"
            label="Отчество плательщика"
            :disabled="true"
        />
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form.paymentAmount"
            :validation="$v.form.paymentAmount"
            label="Сумма платежа"
            :disabled="true"
        />
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form.email"
            :validation="$v.form.email"
            label="E-mail"
            :mask="!isTouchDevice ? 'customEmail' : ''"
        />
        <div class="invoicePay-secondStep__btns">
            <div
                class="invoicePay-secondStep__btns-btn btn"
                @click="$emit('goToFirst')">Назад
            </div>
            <div
                :class="[
                    'invoicePay-secondStep__btns-btn btn __green',
                    { '__invalid': $v.$invalid || sending }
                ]"
                @click="sendForm"
            >
                Оплатить
            </div>
        </div>
        <div
            class="invoicePay-secondStep__error"
            v-if="error"
        >
            {{ error }}
        </div>
        <div class="invoicePay-secondStep__payment-info-description">
            * Нажимая кнопку «Оплатить», вы соглашаетесь с обработкой своих персональных данных АО «Группа компаний «МЕДСИ»
        </div>
        <div class="invoicePay-secondStep__payment-info-links">
            <a
                href="/document_politics.php"
                class="invoicePay-secondStep__payment-info-links-item"
                target="_blank"
            >
                Политика в отношении обработки персональных данных
            </a>
            <a
                href="/document_agreement.php"
                class="invoicePay-secondStep__payment-info-links-item"
                target="_blank"
            >
                Согласие на обработку персональных данных
            </a>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-use-before-define */
import { required, maxLength } from 'vuelidate/lib/validators';
import InvoicePayFormField from "@/components/invoicePay/InvoicePayFormField";
import '@/assets/js/InputmaskAliases';
import formData from "@/assets/js/_formData";
import axios from "axios";

const validations = {
    onlyLetters(value) {
        return (/^[A-Za-zА-Яа-яЁё]([A-Za-zА-Яа-яЁё  \-]+)?$/).test(value); /* eslint-disable-line */
    },
    correctDate(value) {
        return (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/i).test(String(value));
    }
};

export default {
    name: "InvoicePaySecondStep",
    components: {
        InvoicePayFormField
    },
    props: {
        formData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: {
                lastName: '',
                firstName: '',
                patronymic: '',
                email: '',
                paymentAmount: ''
            },
            sending: false,
            error: null,
            isTouchDevice: navigator.userAgent.includes('iPhone') || 
                navigator.userAgent.includes('iPad') || 
                navigator.userAgent.includes('iPod') || 
                navigator.userAgent.includes('Android'),
        }
    },
    methods: {
        sendForm() {
            if (this.$v.$invalid) return;
            this.sending = true;

            const request = formData({
                'invoice_id': this.formData.invoice.invoice_id,
                'email': this.form.email
            });

            axios({
                url: '/local/modules/accord.sberbank/handlers/invoiceCheckAnonym.php',
                method: 'post',
                data: request,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'data-type': 'json',
                    'x-requested-with': 'XMLHttpRequest'
                }
            }).then(response => {
                this.sending = false;

                if (response.data.link) {
                    window.location = response.data.link;
                }
                else {
                    this.error = response.data?.error

                    setTimeout(() => {
                        this.error = null
                    }, 5000)
                }
            })
        },
    },
    validations() {
        return {
            form: {
                lastName: {
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                firstName: {
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                patronymic: {
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                email: {
                    required,
                    maxLength: maxLength(100)
                },
                paymentAmount: {
                    required,
                    maxLength: maxLength(30),
                },
            }
        }
    },
    mounted() {
        if (this.formData.user) {
            this.form.firstName = this.formData.user.firstName
            this.form.lastName = this.formData.user.lastName
            this.form.patronymic = this.formData.user.secondName
        }
        if (this.formData.invoice) {
            this.form.paymentAmount = this.formData.invoice.price
        }
    }
}
</script>

<style lang="scss" scoped>
$p: '.invoicePay-secondStep';

#{$p} {
    position: relative;
    margin-top: 37px;

    &__btns {
        display: flex;
        margin-top: 30px;

        &-btn {
            border-radius: 7px;
            background: #fff;
            color: #0AAEB3;
            border: 1px solid #0AAEB3;
            transition: .2s ease-in-out;
            text-transform: none;
            font-size: 16px;
            border: 1px solid #0AAEB3;
            padding: 10px 40px;
            color: #0AAEB3;
            cursor: pointer;

            &:nth-child(2) {
                margin-left: 12px;
            }

            &:hover {
                background: #0AAEB3;
                color: #fff;
            }

            &.__invalid {
                opacity: .4;
                pointer-events: none;
            }

            &.__green {
                background: #0AAEB3;
                color: #fff;

                &:hover {
                    background: #066d6f;
                }
            }
        }
    }

    &__payment-info {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        padding: 25px 28px 20px 20px;
        background: #FAF9F8;
        border-radius: 16px;

        &-description {
            margin-top: 25px;
            font-weight: 400;
            font-size: 12px;
            line-height: 160%;
            color: #7D7987;
        }

        &-links {
            display: flex;
            flex-direction: column;
            margin-top: 12px;

            &-item {
                margin-right: auto;
                line-height: 22px;
                font-weight: 400;
                font-size: 12px;
                text-decoration: underline;
                color: #00b2ac;
            }
        }
    }

    &__error {
        margin-top: 15px;
        color: #cb2f2f;
        font-size: 14px;
    }
}

</style>